// PWA registration is now handled by VersionBadge.tsx
// This component is kept for backwards compatibility but does nothing
export function PWAUpdatePrompt() {
  return null;
}

